import React, {useState} from 'react';
import { Modal, Button, Input } from 'antd';
import { DIALOG_KEY } from "../../utils/enum";

const ModalDialog = ({ dialog, handleSetDialog }) => {
    const [loading, setLoading] = useState(false);
    if (!dialog || !dialog.open) return null;

    // 응답을 받기 전까지 확인 버튼을 잠가 중복 요청을 막는다.
    const handleOk = async (e) => {
        if (loading) return;
        setLoading(true);
        try {
            await dialog.handle?.(e);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Modal
            open={dialog.open}
            title={dialog.title}
            onCancel={() => !loading && handleSetDialog([{ key: DIALOG_KEY.OPEN, value: false }])}
            closable={!loading}
            footer={[
                <Button key="ok" type="primary" loading={loading} onClick={handleOk}>{dialog.buttonText}</Button>,
                <Button key="cancel" disabled={loading} onClick={() => handleSetDialog([
                    { key: DIALOG_KEY.OPEN, value: false },
                    { key: DIALOG_KEY.CONFIRM_TEXT, value: "" }
                ])}>취소</Button>
            ]}
            centered
            maskClosable={false}
            destroyOnClose
            forceRender={false}
            getContainer={document.body} // 모달을 body에 렌더링하여 항상 최상단에 위치
            zIndex={2000} // zIndex를 충분히 높게 설정
            afterClose={() => handleSetDialog([
                { key: DIALOG_KEY.CONFIRM_TEXT, value: "" }
            ])}
        >
            <div style={{ marginBottom: 16 }}>{dialog.body}</div>
            {dialog.useInput && (
                <Input
                    autoFocus
                    placeholder="확인 문자"
                    value={dialog.confirmText}
                    onChange={e => handleSetDialog([{ key: DIALOG_KEY.CONFIRM_TEXT, value: e.target.value }])}
                />
            )}
        </Modal>
    );
};

export default ModalDialog;